const onlyNumber = /^[0-9]*$/;

export { onlyNumber };
